const eventBus = window.theme.tagalys.searchAutocomplete.eventBus;

class SearchAutoCompleteAPILayer {
  constructor() {

    onTagalysReady(() => {
      this.initializeTagalysSearchAutocomplete();

      eventBus.subscribe('searchAutoComplete:state:term:updated', (term) => {
        window.theme.tagalys.searchAutocomplete.SDK.helpers.updateQuery(term);
      });

      eventBus.subscribe('searchAutoComplete:state:term:submitted', (term) => {
        window.theme.tagalys.searchAutocomplete.SDK.helpers.updateQuery(term);
      });
    })
  }

  initializeTagalysSearchAutocomplete() {
    const { productsLimit, keywordsLimit } = window.theme.tagalys.searchAutocomplete.stateLayer.props;
    window.theme.tagalys.searchAutocomplete.SDK = Tagalys.APIConnector.SearchSuggestions.new({
      params: {
        sections: {
          products: { count: productsLimit },
          searches: { count: keywordsLimit },
        }
      },
      failover: this.initializeShopifySearchAutocomplete.bind(this),
      onSuccess: response => {
        window.theme.tagalys.searchAutocomplete.eventBus.publish('searchAutoComplete:api:results:fetched', response);
        if(response.redirect_url) {
          this.updateSearchInputAction(response.redirect_url);
        } else {
          const term = window.theme.tagalys.searchAutocomplete.stateLayer.term;
          this.updateSearchInputAction('/search?q=' + encodeURIComponent(term));
        }
      },
      onFailure: response => {
        console.error('Failed response:', response)
      }
    })

    this.initializePopularSearches()
  }

  updateSearchInputAction(action) {
    const searchInputs = document.querySelectorAll('form[role="search"]');
    searchInputs.forEach(input => {
      input.action = action;
    });
  }


  initializePopularSearches() {
    window.theme.tagalys.searchAutocomplete.SDK.helpers.getPopularSearches(3).then(response => {
      window.theme.tagalys.searchAutocomplete.eventBus.publish('searchAutoComplete:api:initial:fetched', response);
    })
  }

  initializeShopifySearchAutocomplete() {
    const { productsLimit, keywordsLimit } = window.theme.tagalys.searchAutocomplete.stateLayer.props;
    return Tagalys.APIConnector.ShopifySearchSuggestions.new({
      params: {
        sections: {
          products: { count: productsLimit },
          queries: { count: keywordsLimit },
        },
      },
      onSuccess: response => {
        window.theme.tagalys.searchAutocomplete.eventBus.publish('searchAutoComplete:api:results:fetched', response);
      },
      onFailure: response => {
        console.error('Failed response:', response)
      }
    });
  }
}

window.theme.tagalys.searchAutocomplete.apiLayer = new SearchAutoCompleteAPILayer();
